import { Injectable } from '@angular/core';

class StorageConfig {
  readonly prefix: string = '';
}

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  readonly config = new StorageConfig();

  get keys(): string[] {
    const result: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      result.push(sessionStorage.key(i)!);
    }
    return result;
  }

  get(key: string): any {
    const raw = sessionStorage.getItem(key);
    if (raw === null) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }

  set(key: string, value: any): any {
    if (typeof value === 'string') {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
    return value;
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  readonly config = new StorageConfig();

  get keys(): string[] {
    const result: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      result.push(localStorage.key(i)!);
    }
    return result;
  }

  get(key: string): any {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }

  set(key: string, value: any): any {
    if (typeof value === 'string') {
      localStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
    return value;
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
